let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2JFf7")).then(() => parcelRequire('1mXm0'));